// Location
export const SET_LOCATION_SUCCESS = 'SET_LOCATION_SUCCESS';


// WEBPACK FOOTER //
// ./src/actions/location-actions.js